import { useQuery, useMutation } from '@apollo/client';
import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import { logError } from 'commons/logger';
import useStoreDetails from 'hooks/useStoreDetails';
import { GET_STORE_EMPLOYEES } from 'mocks/queries';
import { SAVE_CART_STORE_DETAILS } from 'mocks/mutations';
import LabeledSelectBox from '../LabeledSelectBox';

const SelectEmployee = ({
  errorMessage,
  employeeSelectRef,
  selectedEmployee,
  onEmployeeChange,
}) => {
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [saveCartStore] = useMutation(SAVE_CART_STORE_DETAILS);
  const storeData = useStoreDetails();

  useQuery(GET_STORE_EMPLOYEES, {
    variables: {
      storeId: storeData?.id,
    },
    skip: !storeData?.id,
    onCompleted: data => {
      const { employees, entered_by } = data?.storeEmployees || {};
      setEmployeeOptions(
        employees?.length
          ? employees.map(employee => ({
              value: employee.real_name,
              label: employee.real_name,
            }))
          : []
      );
      if (entered_by && onEmployeeChange) {
        onEmployeeChange(entered_by, storeData);
      }
    },
    onError: error => logError(error),
  });

  const handleEmployeeChange = useCallback(
    evt => {
      if (!storeData?.id) {
        return;
      }

      const selectedValue = evt.target.value;
      saveCartStore({
        variables: {
          store_id: storeData.id,
          entered_by: selectedValue,
        },
      }).catch(logError);

      if (onEmployeeChange) {
        onEmployeeChange(selectedValue, storeData);
      }
    },
    [saveCartStore, storeData, onEmployeeChange]
  );

  return (
    storeData?.id && (
      <div className="mt-12">
        <span className="font-bold">Did somebody help you today? *</span>
        <LabeledSelectBox
          ref={employeeSelectRef}
          label="Select employee"
          options={employeeOptions}
          value={selectedEmployee}
          errorMessage={errorMessage}
          onChange={handleEmployeeChange}
        />
      </div>
    )
  );
};

SelectEmployee.propTypes = {
  errorMessage: PropTypes.string,
  employeeSelectRef: PropTypes.func,
  onEmployeeChange: PropTypes.func,
  selectedEmployee: PropTypes.string,
};

export default SelectEmployee;
